import { useMemo } from 'react'
import { capitalizeFirstLetter } from 'src/common/utils'
import { ISortSelectOption } from 'src/components/filter/types/filter.types'
import { defaultSelect } from 'src/constants'

import { EScanRecordType } from 'src/types'

export const useScanTypeSelectionOptions = (withSearch: boolean = false) => {
  const scanTypeSelectValues = useMemo(() => {
    const scanTypes: ISortSelectOption[] = Object.values(EScanRecordType).map((scanType) => ({
      label: capitalizeFirstLetter(scanType),
      value: scanType,
    }))

    scanTypes.unshift(defaultSelect)

    return scanTypes
  }, [])

  return {
    selectName: 'scan-type-filter-title.v',
    queryParamName: 'scan_type',
    items: scanTypeSelectValues,
    withSearch,
  }
}
